export const GLOBAL_SETTER = 'GLOBAL_SETTER'
export const GLOBAL_GETTER = 'GLOBAL_GETTER'